import React from 'react';
import {Activities, Redirect, Route, Switch} from 'components';
import {useParams, useNamedSelector} from 'helpers';

export function Router() {
  const { id } = useParams();
  const activity = useNamedSelector('activities.activity', { id });
  if (activity) {
    return (
      <Switch>
        <Route path={[ '/:module(activities|routines|habits|today)/:id/' ]}>
          { ({ match: { params } }) => <Activities.Single.EditForm {...params} /> }
        </Route>
      </Switch>
    );
  }
  return (
    <Redirect to="../" />
  );
}
